export default {
  title: "Обележани",
  subtitle: "Вашите обележани ставки",
  comingSoon: "Наскоро",
  description:
    "Оваа функција ќе ви овозможи да обележувате и брзо да пристапувате до важни ставки.",
};
